/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenQrBidvVADto } from '../models/GenQrBidvVADto';
import type { GenQrBidvVAEntity } from '../models/GenQrBidvVAEntity';
import type { GetQrBidvVAEntity } from '../models/GetQrBidvVAEntity';
import type { InquiryBidvVADto } from '../models/InquiryBidvVADto';
import type { InquiryBidvVAEntity } from '../models/InquiryBidvVAEntity';
import type { SyncTransactionsBidvVADto } from '../models/SyncTransactionsBidvVADto';
import type { SyncTransactionsBidvVAEntity } from '../models/SyncTransactionsBidvVAEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BidvVirtualAccountService {

    /**
     * Generate QR code for BIDV Virtual Account
     * @param endCode End Code / Payer ID
     * @param requestBody
     * @returns GenQrBidvVAEntity
     * @throws ApiError
     */
    public static bidvVaControllerGenQr(
        endCode: string,
        requestBody: GenQrBidvVADto,
    ): CancelablePromise<GenQrBidvVAEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/bidv-vas/{endCode}/gen-qr',
            path: {
                'endCode': endCode,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get QR image for BIDV Virtual Account
     * @param endCode End Code / Payer ID of the Virtual Account
     * @returns GetQrBidvVAEntity
     * @throws ApiError
     */
    public static bidvVaControllerGetQr(
        endCode: string,
    ): CancelablePromise<GetQrBidvVAEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/bidv-vas/{endCode}/qr',
            path: {
                'endCode': endCode,
            },
        });
    }

    /**
     * Inquiry transaction status for BIDV Virtual Account
     * @param endCode End Code / Payer ID
     * @param requestBody
     * @returns InquiryBidvVAEntity
     * @throws ApiError
     */
    public static bidvVaControllerInquiry(
        endCode: string,
        requestBody: InquiryBidvVADto,
    ): CancelablePromise<InquiryBidvVAEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/bidv-vas/{endCode}/inquiry',
            path: {
                'endCode': endCode,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Sync transactions from BIDV and process missed callbacks
     * @param endCode End Code / Payer ID
     * @param requestBody
     * @returns SyncTransactionsBidvVAEntity
     * @throws ApiError
     */
    public static bidvVaControllerSyncTransactions(
        endCode: string,
        requestBody: SyncTransactionsBidvVADto,
    ): CancelablePromise<SyncTransactionsBidvVAEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/bidv-vas/{endCode}/sync-transactions',
            path: {
                'endCode': endCode,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
